module.exports = __webpack_public_path__ + "static/media/switch.087b83a1.png";